'use strict';
var quickview = {};
var updateAddToCart = require('./updateAddToCart');
var base = require('./base');
var persistentWishlist = require('core/product/persistentWishlist');

/** Constants */
const $body = $('body');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
  const $quickViewModal = $('#quickViewModal');
  const $consentTracking = $('#consent-tracking');

  $quickViewModal.remove();
  $consentTracking.remove();

  var htmlString =
    '<!-- Modal -->' +
    '<div class="modal fade" id="quickViewModal" role="dialog" aria-modal="true">' +
    '<span class="enter-message sr-only" ></span>' +
    '<div class="modal-dialog quick-view-dialog">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-body"></div>' +
    '</div>' +
    '</div>' +
    '</div>';
  $body.append(htmlString);
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
  var $html = $('<div>').append($.parseHTML(html));

  var body = $html.find('.product-quickview');
  var footer = $html.find('.modal-footer').children();

  return {
    body: body,
    footer: footer
  };
}

/**
 * QV activate primary selected image zoom
 *
 * @param {this} $this - current element
 **/
function activateQVPrimaryImageZoom($this) {
  if ($('.enableQVZoomer').length > 0) {
    var $element = $this.closest('.product-quickview');
    var serverUrl = $element.find('div.pdp-carousel').data('scene7hosturl');
    var asset;
    var image;
    var params = {};
    image = $this.attr('src').split('image/'); // eslint-disable-line
    asset = image[image.length - 1];
    params.asset = asset;
    params.serverurl = serverUrl;
    var containerId = $this.closest('.primary-image').find('.s7-viewer-qv').attr('id');
    var zoomViewer = new s7viewers.FlyoutViewer({
      // eslint-disable-line
      containerId: containerId, // eslint-disable-line
      params: params // eslint-disable-line
    }).init();
    $this.addClass('hide');
  }
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {Object} pageData - back up page data to be used for adobe tag manager
 */
function fillModalElement(selectedValueUrl, pageData) {
  $.spinner().start();
  $.ajax({
    url: selectedValueUrl,
    method: 'GET',
    dataType: 'json',
    success: async function (data) {
      if (!window.s7viewers) {
        var s7viewersLoad = require('core/util/s7viewers').loadS7ViewersScripts;
        var s7APIForPDPVideoPlayer = data.s7APIForPDPVideoPlayer ? data.s7APIForPDPVideoPlayer : '';
        var s7APIForPDPZoomViewer = data.s7APIForPDPZoomViewer ? data.s7APIForPDPZoomViewer : '';
        await s7viewersLoad(s7APIForPDPVideoPlayer, s7APIForPDPZoomViewer);
      }

      var parsedHtml = parseHtml(data.renderedTemplate);
      const $quickViewModal = $('#quickViewModal');

      $quickViewModal.find('.modal-body').html(parsedHtml.body);
      $quickViewModal.find('.modal-footer').html(parsedHtml.footer);
      $quickViewModal.find('.size-chart').attr('href', data.productUrl);
      $quickViewModal.find('.view-full-product-info').attr('href', data.productUrl);
      $quickViewModal.find('.enter-message').text(data.enterDialogMessage);
      $quickViewModal.css({
        visibility: 'hidden'
      });
      $quickViewModal.modal('show');

      $body.trigger('adobeTagManager:showQuickView', data.product);

      // add review on quick view
      require('core/product/teasersQV').addReviews();

      $.ajax({
        url: data.tfcQvUrl,
        type: 'get',
        dataType: 'json',
        data: {},
        success: function (response) {
          $('.quick-view-dialog').find('.tf-qv-content').empty().html(response.renderedTemplate);
          if ($('.enableTruefit').length > 0 && $('.enableTruefit').val() === 'true') {
            tfcapi('calculate'); // eslint-disable-line
          }
        },
        error: function () {
          // do nothing
        }
      });

      $body.on('input', '.quantity-val', function () {
        const $this = $(this);
        var maxValue = parseInt($this.attr('max'), 10);
        if ($this.val() >= maxValue) {
          $this.val(maxValue);
          $this.closest('div').find('select[class*="quantity-select"]').val(maxValue).trigger('change');
          $this.prev('span').find('button').removeAttr('disabled');
        }
      });
      setTimeout(function () {
        base.activatePrimarySlick();
        base.activateVideoPlayer();
        window.hbcTooltip.tooltipInit();
        window.formFields.updateSelect();
        window.formFields.quantityHoverBorder();
        // $('.TTteaser__read-reviews').attr('href', $('.view-full-product-info').attr('href'));

        $('.quickview-close, .view-full-product-info, .TTteaser__read-reviews').on('click', function (e) {
          const $this = $(this);

          try {
            const pid = $this.closest('.product-quickview').data('pid');

            persistentWishlist.makrSingleProductWishlisted(pid, $('#' + pid));
            // refresh the page on wishlist upon close of QV. This is to remove the tile on Wishlist landing page
            if (e.currentTarget.className.indexOf('quickview-close') > -1 && $('.page').data('action') == 'Wishlist-Show' && $('input[name="wishlistUpdated"]').val() === 'true') {
              $body.addClass("position-relative");
              $.spinner().start();
              window.location.reload();
            }
          } catch (ex) {
            //eslint-disable-line
            // do nothing
          }

          $body.trigger('adobeTagManager:closeWidget', pageData);

          $('#quickViewModal').modal('hide');
        });
        $('.product-quickview').on('click', '.primary-image img', function () {
          activateQVPrimaryImageZoom($(this));
        });
        $.spinner().stop();
        const $quickViewModal = $('#quickViewModal');
        $quickViewModal.css({
          visibility: 'visible'
        });
        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 && navigator.userAgent.indexOf('CriOS/') == -1) {
          if(window.innerWidth >= 1024) {
            var qvImage = $(".search-page  #quickViewModal .quickview_container .primary-image img");
            var qvImageHeight = (qvImage.width() * (4/3));
            qvImage.css('height', qvImageHeight);
          }
        }

        $quickViewModal.find('.quickview_container').focus();
        const $productQuickView = $('.product-quickview');
        try {
          persistentWishlist.makrSingleProductWishlisted(data.product.id, $productQuickView);
          base.checkProductAvailability(data.product.productType, data.availabilityUrl, $productQuickView);
        } catch (e) {
          //eslint-disable-line
          // do nothing
        }
      }, 300);
    },
    error: function () {
      $.spinner().stop();
    }
  });
}

quickview.showQuickview = function () {
  $body.on('click', '.quickview', function (e) {
    e.preventDefault();
    // Backup page data for reload after close quick view window
    const $this = $(this);
    const $productTile = $this.closest('.product-tile');
    let pd = {
      type: window.pageData.page.type,
    }
    var selectedValueUrl = $this.closest('a.quickview').data('quickviewUrl');
    $(e.target).trigger('quickview:show');
    var pid = $this.closest('.product').data('pid');
    var selectedColorValue = $productTile.find('.colorswatch.selected').data('attrValue');
    if (pid && selectedColorValue) {
      selectedValueUrl= selectedValueUrl +'&dwvar_' + pid + '_color=' + selectedColorValue;
    }
    var colorToSelect = $productTile.find('input[name="colorToSelect"]').val();
    if (colorToSelect) {
      selectedValueUrl = selectedValueUrl + '&colorToSelect=' + colorToSelect;
    }
    getModalHtmlElement();
    fillModalElement(selectedValueUrl, pd);
  });
};

quickview.focusQuickview = function () {
  $body.on('shown.bs.modal', '#quickViewModal', function () {
      $('#quickViewModal .close').focus();
  });
};

quickview.trapQuickviewFocus = function () {
  $body.on('keydown', '#quickViewModal', function (e) {
      var focusParams = {
          event: e,
          containerSelector: '#quickViewModal',
          firstElementSelector: '.full-pdp-link',
          lastElementSelector: '.add-to-cart-global',
          nextToLastElementSelector: '.modal-footer .quantity-select'
      };
      focusHelper.setTabNextFocus(focusParams);
  });
};

quickview.showSpinner = function () {
  $body.on('product:beforeAddToCart', function (e, data) {
      $(data).closest('.modal-content').spinner().start();
  });
}

quickview.hideDialog = function () {
  $body.on('product:afterAddToCart', function () {
      $('#quickViewModal').modal('hide');
  });
}

quickview.beforeUpdateAttribute = function () {
  $body.on('product:beforeAttributeSelect', function () {
    $('.modal.show .modal-content').spinner().start();
  });
};

quickview.updateAttribute = function () {
  $body.on('product:afterAttributeSelect', function (e, response) {
    const $modalShow = $('.modal.show');
    if ($modalShow.find('.product-quickview>.bundle-items').length) {
      const $container = $modalShow.find(response.container);
      $container.data('pid', response.data.product.id);
      $container.find('.product-id').text(response.data.product.id);
      $container.find('.bf-product-id').text(response.data.product.id);
    } else if ($('.set-items').length) {
      response.container.find('.product-id').text(response.data.product.id);
      response.container.find('.bf-product-id').text(response.data.product.id);
    } else {
      $modalShow.find('.product-quickview').data('pid', response.data.product.id);
      $modalShow.find('.full-pdp-link').attr('href', response.data.product.selectedProductUrl);
    }
  });
};

quickview.updateAvailability = function () {
  $body.on('product:updateAvailability', function (e, response) {
    // bundle individual products
    $('.product-availability', response.$productContainer)
      .data('ready-to-order', response.product.readyToOrder)
      .data('available', response.product.available)
      .find('.availability-msg').html(response.message);

    var dialog = $(response.$productContainer).closest('.quick-view-dialog');
    const $productAvailability = $('.product-availability', dialog);
    const $globalAvailability = $('.global-availability', dialog);

    if ($productAvailability.length) {
      // bundle all products
      var allAvailable = $productAvailability.toArray().every(function (item) {
        return $(item).data('available');
      });
      var allReady = $productAvailability.toArray().every(function (item) {
        return $(item).data('ready-to-order');
      });

      $globalAvailability.data({
        'ready-to-order': allReady,
        'available': allAvailable
      }).find('.availability-msg').html(allReady ? response.message : response.resources.info_selectforstock);
    } else {
      // single product
      $globalAvailability.data({
        'ready-to-order': response.product.readyToOrder,
        'available': response.product.available
      }).find('.availability-msg').html(response.message);
    }
  });
};

quickview.addToCart = base.addToCart;
quickview.availability = base.availability;
quickview.updateAddToCart = updateAddToCart;

module.exports = quickview;
